<template>
  <div>
    <div :class="['popover-bg', {show: popoverShow, animate: animate}]" @touchmove.prevent></div>
    <div :class="['custom-popover', {show: popoverShow, animate: animate}]" :style="{bottom: bottom || 0}">
      <div class="popover-title" v-if="title">
        <span>{{title}}</span>
      </div>
      <div class="btn-close" @click="triggerClose">
        <img class="icon-close" src="../assets/icons/icon_close.png" />
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomPopover',

  props: {
    show: Boolean,
    title: {
      type: String,
      default: ''
    },
    bottom: {
      type: String,
      default: '0'
    }
  },

  data () {
    return {
      popoverShow: false,
      animate: false,
      animationData: {}
    }
  },

  watch: {
    show: {
      handler (newVal) {
        if (newVal) {
          this.popoverShow = true
          setTimeout(() => {
            this.animate = true
          }, 50)
        } else {
          this.animate = false
          setTimeout(() => {
            this.popoverShow = false
          }, 300)
        }
      },
      immediate: true
    }
  },

  methods: {
    triggerClose () {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popover-bg {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1999;
  opacity: 0;
  background-color: rgba(0,0,0,0.6);
  transition: opacity .3s;
}
.popover-bg.show,
.custom-popover.show {
  display: block;
}
.popover-bg.animate {
  opacity: 1;
}
.custom-popover {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  border-top: 6px solid #febc10;
  background-color: #fff;
  transition: all .3s;
  transform: translateY(100%);
}
.custom-popover.animate {
  transform: translateY(0);
}
.popover-title {
  position: relative;
  height: 98px;
  box-sizing: border-box;
  padding: 0 30px;
  font-size: 32px;
  color: #000;
  font-weight: bold;
  line-height: 92px;
}
.btn-close {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  border-bottom-left-radius: 20px;
  background-color: #febc10;
}
.icon-close {
  width: 32px;
  height: 32px;
}
</style>
